const BOOKINGS = 'bookings';
const CONFIRMATION = 'confirmation';
const INBOX = 'inbox';
const MY_TRIPS = 'mytrips';

const HOMEAWAY_AS_DISPLAY_STRING = 'HomeAway';
const VRBO_AS_DISPLAY_STRING = 'Vrbo';
const VRBO_LOGO =
    'https://csvcus.homeaway.com/rsrcs/cdn-logos/4.7.0/sitename/vrbo/web/touch-icon-iphone.png';

const appBannerCtaLinks = {
    homeaway: {
        inbox: 'https://t.hmwy.io/FERmK3HrD3',
        mytrips: 'https://t.hmwy.io/EpaEUzEBt5',
    },
    vrbo: {
        inbox: 'https://t.vrbo.io/rE2P1y0qQ3',
        mytrips: 'https://t.vrbo.io/tpErRkuBt5',
    },
};

const appModalCtaLinks = {
    homeaway: {
        confirmation: 'https://t.hmwy.io/eCqNC24aDab',
        mytrips: 'https://t.hmwy.io/PftghSQV08',
    },
    vrbo: {
        confirmation: 'https://t.vrbo.io/CMAnLirhAab',
        mytrips: 'https://t.vrbo.io/M19crbFV08',
    },
};

const recoCarousalBreakpoints = {
    480: 4,
    380: 3,
    320: 2,
};

const editReservationAttribute = {
    NEW_BEGIN_DATE: 'newBeginDate',
    NEW_CHECKIN_TIME: 'newCheckInTime',
    NEW_CHECKOUT_TIME: 'newCheckOutTime',
    NEW_END_DATE: 'newEndDate',
    NEW_FIRST_NAME: 'newFirstName',
    NEW_LAST_NAME: 'newLastName',
    NEW_MOBILE: 'newMobile',
    NEW_NUM_ADULTS: 'newNumAdults',
    NEW_NUM_CHILDREN: 'newNumChildren',
    NEW_PHONE: 'newPhone',
    NEW_TRAVELER_EMAIL: 'newTravelerEmail',
    OLD_BEGIN_DATE: 'oldBeginDate',
    OLD_CHECKIN_TIME: 'oldCheckInTime',
    OLD_CHECKOUT_TIME: 'oldCheckOutTime',
    OLD_END_DATE: 'oldEndDate',
    OLD_FIRST_NAME: 'oldFirstName',
    OLD_LAST_NAME: 'oldLastName',
    OLD_MOBILE: 'oldMobile',
    OLD_NUM_ADULTS: 'oldNumAdults',
    OLD_NUM_CHILDREN: 'oldNumChildren',
    OLD_PHONE: 'oldPhone',
    OLD_TRAVELER_EMAIL: 'oldTravelerEmail',
};

const editReservationRequestAttribute = {
    NEW_BEGIN_DATE: 'newBeginDate',
    NEW_END_DATE: 'newEndDate',
    NEW_NUM_ADULTS: 'newNumAdults',
    NEW_NUM_CHILDREN: 'newNumChildren',
    OLD_BEGIN_DATE: 'oldBeginDate',
    OLD_END_DATE: 'oldEndDate',
    OLD_NUM_ADULTS: 'oldNumAdults',
    OLD_NUM_CHILDREN: 'oldNumChildren',
};

const messageType = {
    EDIT_RESERVATION: 'EDIT_RESERVATION',
    EDIT_RESERVATION_REQUEST: 'EDIT_RESERVATION_REQUEST',
};

export {
    BOOKINGS,
    CONFIRMATION,
    HOMEAWAY_AS_DISPLAY_STRING,
    INBOX,
    MY_TRIPS,
    VRBO_AS_DISPLAY_STRING,
    VRBO_LOGO,
    appBannerCtaLinks,
    appModalCtaLinks,
    editReservationAttribute,
    editReservationRequestAttribute,
    messageType,
    recoCarousalBreakpoints,
};
